import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";

const EditorNotificaciones = ({ name, value, onChange, error, label }) => {
  const toolbarOptions = [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['link'],
    [{ 'align': [] }],
    ['clean']
  ];

  const modules = {
    toolbar: {
      container: toolbarOptions,
    }
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link',
    'align'
  ];

  return (
    <div style={{ position: 'relative', zIndex: 1 }}>
      <label className="form-label fw-semibold text-primary-light mb-2">
        {label}
        <span className="text-danger ms-1"></span>
      </label>
      <div 
        className="quill-wrapper"
        style={{ 
          borderColor: error ? 'var(--danger-main)' : '', 
          borderWidth: error ? '1px' : '', 
          borderStyle: error ? 'solid' : '', 
          borderRadius: error ? '10px' : '',
          height: '350px',
          marginBottom: '20px'
        }}
      >
        <ReactQuill 
          theme="snow" 
          value={value || ''} 
          onChange={(value) => onChange({ target: { name: name, value } })} 
          modules={modules}
          formats={formats}
          style={{ 
            height: '100%',
          }}
        />
      </div>
      {error && (
        <div className="text-danger mt-2" style={{ fontSize: '15px' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default EditorNotificaciones;
